import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 8px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
`;

export const EmojiWrapper = styled.span`
  display: flex;
  width: 64px;
  height: 64px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-size: 40px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`;

export const TitleText = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const SubtitleText = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black7};
`;
